export const COMPANY_DECLINED_URL_PARAMETER = 'companyDeclined=true';
